import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { finalize, map, switchMap, tap } from 'rxjs';
import { AppLoaderService } from 'src/app/services/app-loader.service';
import LogsActions from '../../actions/generations/summary.actions';

@Injectable()
export class WizardCompletionEffects {
  private readonly actions = inject(Actions);
  private readonly httpService = inject(HttpBaseService);
  private readonly loaderService = inject(AppLoaderService);

  getAllLogs$ = createEffect(() =>
    this.actions.pipe(
      ofType(LogsActions.getAllLogs),
      tap(() => {
        this.loaderService.show();
      }),
      switchMap((action: any) => {
        const { apiConstants, urlPathVariables } = action;
        return this.httpService[apiConstants.method](apiConstants, urlPathVariables).pipe(
          map((response: any) => LogsActions.setLogs({ data: response })),
          finalize(() => {
            this.loaderService.hide();
          })
        );
      })
    )
  );
  deleteLogs$ = createEffect(() =>
    this.actions.pipe(
      ofType(LogsActions.deleteLogs),
      tap(() => {
        this.loaderService.show();
      }),
      switchMap((action: any) => {
        const { apiConstants, urlPathVariables } = action;
        return this.httpService[apiConstants.method](apiConstants, urlPathVariables).pipe(
          map((response: any) => LogsActions.clearLogs()),
          finalize(() => {
            this.loaderService.hide();
          })
        );
      })
    )
  );
}
